import { IModel, IAttribute } from '../../base/annotation';
import { Metamodel } from 'app/model/base/model';
import { TabularCopySource } from 'app/model/pipeline/copysource/tabular-type.copysource';

import { CassandraDataset } from 'app/model/dataset/cassandra.dataset';
import { adfModelTypeMap } from 'app/registries/consts/adf-model-type-map-const';

@Metamodel.model({
    name: adfModelTypeMap.cassandra.copySourceType,
    display: [],
    tags: { datasetModel: Metamodel.modelFor(CassandraDataset) }
})
export class CassandraCopySource extends TabularCopySource {
    public static readonly MODEL: IModel;
    public static readonly CONSISTENCY_LEVEL: IAttribute;

    @Metamodel.attribute({
        display: stringResources.ModelName_Cassandra_ConsistencyLevel,
        association: 'CONSISTENCY_LEVEL',
        templatable: true,
        constraint: {
            allowed: ['one', 'two', 'three', 'quorum', 'all', 'local_quorum', 'each_quorum', 'local_one']
        }
    })
    public consistencyLevel?: string = 'one';
}
